import { render, staticRenderFns } from "./CustomTimeHeader.vue?vue&type=template&id=3b08a0d1&lang=html"
import script from "./CustomTimeHeader.vue?vue&type=script&lang=js"
export * from "./CustomTimeHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomTimeHeader.vue?vue&type=style&index=0&id=3b08a0d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports